// Contenuti del sito pubblico (home, /chi-sono, /privacy).

export const CONTACT = {
  email: "mara@designermara.it",
};

export const AUTHOR = "Mariana Radova";

// Foto dell'autrice (servita dal backend assets del mobile non disponibile sul web:
// usiamo un ritratto neutro; sostituibile con la foto reale).
export const MARA_PHOTO =
  "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=600";

export const HERO_PHOTO =
  "https://images.pexels.com/photos/827528/pexels-photo-827528.jpeg?auto=compress&cs=tinysrgb&w=1200";

export const CASES = [
  {
    title: "Tavoline",
    what: "Menu digitale con QR, ordini dal tavolo e schermo di cucina per i ristoranti.",
    time: "Due settimane",
    image: "",
  },
];

export const PRIVACY_TEXT = `Ultimo aggiornamento: giugno 2026

Tavoline consente ai ristoranti di pubblicare il proprio menu tramite QR code e di ricevere ordini al tavolo. Questa informativa spiega quali dati trattiamo e come.

1. Titolare del trattamento
Mariana Radova — ${CONTACT.email}

2. Dati che trattiamo
- Dati dell'account del ristoratore: nome, email, password (in forma cifrata), dati del locale (nome, città, indirizzo, telefono).
- Dati generati dall'uso: menu, piatti, prezzi, ordini, sessioni ai tavoli.
- Dati dei clienti del ristorante: un nome facoltativo indicato al tavolo e il contenuto delle ordinazioni. Non chiediamo ai clienti dati di pagamento.

3. Finalità e base giuridica
Trattiamo i dati per fornire il servizio, per la sicurezza e per adempimenti di legge. Non vendiamo i dati a terzi.

4. Conservazione
Conserviamo i dati per il tempo necessario a fornire il servizio. Gli ordini più vecchi vengono eliminati o resi anonimi periodicamente.

5. Servizi terzi
Usiamo fornitori per l'hosting, l'archiviazione delle immagini e l'invio di email. Trattano i dati per nostro conto.

6. Sicurezza
I dati viaggiano su connessione cifrata (HTTPS) e le password sono conservate in forma cifrata.

7. I tuoi diritti
Puoi chiedere accesso, rettifica o cancellazione dei tuoi dati. Puoi eliminare l'account in qualsiasi momento dalle Impostazioni, oppure scrivere a ${CONTACT.email}.`;
